import merge from 'deepmerge';
import NewHomeSourcePartner from 'constants/partner';
import matchesMobileUserAgent from 'modules/deviceCapabilities';
import { selectUrlSubdirectory } from 'features/routing';
import PageType from 'enums/pageType';
import selectTrackingCommonProperties from './redux/selectors';

const businnessInformationElement = document.querySelector("[data-component='business-information-data']");
const businnessInformation = JSON.parse(businnessInformationElement.innerHTML);

const getResponseVersion = (isMobileDevice) => (isMobileDevice ? 'M' : 'D');

/**
 * The getCommonPropertiesFromOtherSources function returns an object containing the properties obtained from:
 * sources such as html, or consts.
 * @return An object with the properties not stored in redux.
 */
const getCommonPropertiesFromOtherSources = (store) => {
  const urlSubdirectory = selectUrlSubdirectory(store);
  const pageType = PageType.fromKey(urlSubdirectory).toString();
  const isMobileUserAgent = matchesMobileUserAgent();
  const properties = {
    pageType,
    buildCodeVersion: businnessInformation.buildCodeVersion,
    responseVersion: getResponseVersion(isMobileUserAgent),
    testVersion: NewHomeSourcePartner.testVersion,
    partnerId: NewHomeSourcePartner.partnerId,
    partnerName: NewHomeSourcePartner.partnerName,
    brandPartnerName: NewHomeSourcePartner.brandPartnerName,
  };

  return properties;
};

/**
 * The function returns common tracking properties that are stored in the redux store.
 * @param store - The `store` parameter is likely an object representing a store or a state management
 * @returns an object containing the properties stored in a redux store.
 */
const getCommonPropertiesFromStore = (store) => {
  const trackingCommonPropertiesFromStore = selectTrackingCommonProperties(store);

  return trackingCommonPropertiesFromStore;
};

/**
 * The getTrackingCommonProperties function returns tracking common properties from the Redux store.
 * this uses a selector which takes from other features selectors a set of properties and combines them.
 * The idea is that this selctor can be used for different tracking consumets such as segment, g4.
 * by a respective object builder which will filter that properties as needed.
 * @param store Access the redux store
 *
 * @return An object of properties.
 */
const getTrackingCommonProperties = (store) => {
  const trackingCommonPropertiesFromStore = getCommonPropertiesFromStore(store);
  const trackingCommonPropertiesFromOtherSources = getCommonPropertiesFromOtherSources(store);
  const trackingCommonProperties = merge(trackingCommonPropertiesFromStore, trackingCommonPropertiesFromOtherSources);

  return trackingCommonProperties;
};

export default getTrackingCommonProperties;
